import { createSelector, type OutputSelector } from 'reselect';
import type { CollectionsTourSteps, State } from './GlobalFieldsTourSteps.types.tsx';

export const getCollectionsFlow = (
	state: State,
): {
	tourDismissed?: boolean;
	tourSpotlightStep: CollectionsTourSteps | null;
	introductionDismissed?: boolean;
	introductionPrerequisiteDismissalsMet?: boolean;
} => state.collections;

export const getCollectionsTourDismissed: OutputSelector<
	State,
	boolean | undefined,
	(res: {
		tourDismissed?: boolean;
		tourSpotlightStep: CollectionsTourSteps | null;
		introductionDismissed?: boolean;
		introductionPrerequisiteDismissalsMet?: boolean;
	}) => boolean | undefined
> = createSelector(getCollectionsFlow, (collections) => collections.tourDismissed);

export const getTourSpotlightStep: OutputSelector<
	State,
	CollectionsTourSteps | null,
	(res: {
		tourDismissed?: boolean;
		tourSpotlightStep: CollectionsTourSteps | null;
		introductionDismissed?: boolean;
		introductionPrerequisiteDismissalsMet?: boolean;
	}) => CollectionsTourSteps | null
> = createSelector(getCollectionsFlow, (collections) => collections.tourSpotlightStep);

export const getCollectionsIntroductionDismissed: OutputSelector<
	State,
	boolean | undefined,
	(res: {
		tourDismissed?: boolean;
		tourSpotlightStep: CollectionsTourSteps | null;
		introductionDismissed?: boolean;
		introductionPrerequisiteDismissalsMet?: boolean;
	}) => boolean | undefined
> = createSelector(getCollectionsFlow, (collections) => collections.introductionDismissed);

export const getCollectionsIntroductionPrerequisiteDismissalsMet: OutputSelector<
	State,
	boolean | undefined,
	(res: {
		tourDismissed?: boolean;
		tourSpotlightStep: CollectionsTourSteps | null;
		introductionDismissed?: boolean;
		introductionPrerequisiteDismissalsMet?: boolean;
	}) => boolean | undefined
> = createSelector(
	getCollectionsFlow,
	(collections) => collections.introductionPrerequisiteDismissalsMet,
);
